import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Twitter } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  const quickLinks = [
    { label: t('home'), path: '/' },
    { label: t('about'), path: '/about' },
    { label: t('divisions'), path: '/divisions' },
    { label: t('services'), path: '/services' },
    { label: t('projects'), path: '/projects' },
    { label: t('contact'), path: '/contact' },
  ];

  return (
    <footer className="bg-[#141F48] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Logo & Tagline */}
          <div className="lg:col-span-2">
            <img
              src="/assets/logos/almad-footer-logo.png"
              alt="ALMAD Contracting"
              className="h-16 w-auto mb-4"
            />
            <p className="text-[#D3BC8D] text-lg font-medium mb-4">{t('footerTagline')}</p>
            <p className="text-gray-300 text-sm leading-relaxed">
              {t('heroSubtitle')}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-[#D3BC8D] font-semibold text-lg mb-4">{t('quickLinks')}</h3>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-gray-300 hover:text-[#D3BC8D] transition-colors duration-200 text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-[#D3BC8D] font-semibold text-lg mb-4">{t('contact')}</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#D3BC8D] flex-shrink-0 mt-0.5" />
                <span className="text-gray-300 text-sm">
                  King Abdulaziz Road Tower, 12th Floor, Office 1208, Jeddah 23412, KSA
                </span>
              </li>
              <li className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#D3BC8D]" />
                <span className="text-gray-300 text-sm">+966 (0) 596 817 974</span>
              </li>
              <li className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#D3BC8D]" />
                <span className="text-gray-300 text-sm">info@almad.com</span>
              </li>
            </ul>
            <div className="flex space-x-4 mt-6">
              <a
                href="#"
                className="text-white hover:text-[#D3BC8D] transition-colors duration-200"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="#"
                className="text-white hover:text-[#D3BC8D] transition-colors duration-200"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/10 text-center">
          <p className="text-gray-400 text-sm">{t('allRightsReserved')}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;